export default __webpack_public_path__ + "files/missouri_stations_v5-dbca967218d87f7e4561b2723546c3ee.pbf";